<template>
    <div id="ieExpro">
        <a-row>

            <a-col :span="11">
                <t-asn></t-asn>
            </a-col>

            <a-col :span="11">
                <h-so></h-so>
            </a-col>

        </a-row>
        <a-row>
            <p-po></p-po>
        </a-row>
    </div>
</template>
<script>
    import tAsn from './asn.vue'
    import hSo from './so.vue'
    import pPo from './po.vue'
    export default{
        components:{
            tAsn,
            hSo,
            pPo
        }
    }
</script>